var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.resolvedComponent)?_c(_vm.resolvedComponent,{tag:"component"}):_c('div',[_c('v-container',[_c('v-row',[_c('v-col',[_c('v-alert',{attrs:{"type":"error"}},[_vm._v(" Invalid or missing referrer. Please contact support. ")])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }